export default __webpack_public_path__ + "static/fx-13f6144b2c468841113db53b0cfe2bfe.svg";